<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="prefix + title">
            <perfilList :prefix="prefix" @onselect="handleSelect" />
        </b-modal>

        <lg-form-input-finder v-model="localValue" fieldDescription="perfil" :label="label" :showClear="!disabled"
            invalidFeedback="Perfil deve ser informado!" description="" @handleClean="handleSelect"
            :disabled="disabled">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed v-if="!disabled">
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import PerfilList from "@/modules/gerenciamento/perfil/PerfilList.vue";

export default {
    components: { LgFormInputFinder, PerfilList },

    props: {
        disabled: {
            type: Boolean,
            default: false,
        },

        id: String,
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Perfil",
        },
        label: {
            type: String,
            default: "Perfil:"
        }


    },
    data() {
        return {
            localValue: this.value,

            fields: [
                {
                    key: "action",
                    label: " ",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
                {
                    key: "perfil",
                    label: "Nome",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
            ],

        };
    },
    methods: {
        async show() {
            await this.$refs.finder.show();
        },

        async handleSelect(item) {
            this.localValue = item;
            this.$emit("onselect", item);
            await this.$bvModal.hide(this.id);
        },

        async showPerfil() {
            await this.$refs.finderPerfil.show();
        },
    },
};
</script>
